import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getHousingUnitSummaryCard } from 'constants/routes'

/**
 * Retrieves an interactive site plan housing unit summary card..
 * @param {int} specId - The payload containing the spec id.
 * @param {int} communityId - The payload containing the community id.
 * @param {int} marketId - The payload containing the market id.
 * @returns {Observable} - An observable that emits the spec summary card information.
 */
const getHousingUnitSummaryCardInformation = (specId, communityId, marketId) => {
  const params = new URLSearchParams();
  params.append('id', specId);

  if (communityId) {
    params.append('communityId', communityId);
  }

  if (marketId) {
    params.append('marketId', marketId);
  }

  const url = `${getHousingUnitSummaryCard}?${params.toString()}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json())
  );
};

export default getHousingUnitSummaryCardInformation;